import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';
import logo from '../../../assets/img/reactlogo.png';
let backendUrl = process.env.REACT_APP_BACKEND_URL;
const today = new Date().toISOString().split('T')[0];

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    backgroundColor: '#ffffff'
  },
  section: {
    marginBottom: 5
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 5
  },
  headerText: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: "center"
  },
  image: {
    width: 100
  },
  provider: {
    height: 50
  },
  date: {
    fontSize: 12,
    textAlign: 'right'
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf'
  },
  tableRow: {
    flexDirection: "row"
  },
  tableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0'
  },
  tableCol: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf'
  },
  tableCellHeader: {
    margin: 6,
    fontSize: 11,
    fontWeight: "bold"
  },
  tableCell: {
    margin: 6,
    fontSize: 11
  },
  footerContainer: {
    marginTop: 20
  },
  companyMainText: {
    fontSize: 11,
    fontWeight: 'bold'
  },
  companyText: {
    fontSize: 9
  },
  totalCost: {
    fontSize: 12,
    fontWeight: 'bold'
  },
});

function RechargeReport() {
  const [currentDate, setCurrentDate] = useState('');
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState(false);
  const [userId, setUserId] = useState("");
  const currentUser = useSelector((state) => state.data);
  const [data, setData] = useState(false);
  const [recordData, setRecordData] = useState(false);
  const [users, setUsers] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [singleTransectionRow, setSingleTransectionRow] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );

  const PrintPDF = () => (
    typeof window !== 'undefined' && (<Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View style={styles.headerContainer}>
            <Image style={styles.image} src={logo} />
            <Text style={styles.headerText}>Transaction Summary</Text>
            {
              data && singleTransectionRow && singleTransectionRow.map(data => (
                data.key == "Provider" &&
                data.val

              ))
            }
          </View>
          <View>
            <Text style={styles.companyMainText}>Pargati online service PVT LTD, SCO 832, 2nd floor, Cabin no. 10, NAC Manimajra Chandigah</Text>
            <Text style={styles.companyText}>Office Working Days: Monday To Saturday</Text>
            <Text style={styles.companyText}>Timing: 10:00 AM To 6:00 PM</Text>
            <Text style={styles.companyText}>Help Line: 01724049681</Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Recharge Report</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Detail</Text>
            </View>
          </View>
          {
            data && singleTransectionRow && singleTransectionRow.map(data => (
              data.key != "Provider" && data.key != "" && (
                <View style={styles.tableRow}>
                  <View style={styles.tableColHeader}>
                    <Text style={styles.tableCellHeader}>{data.key}:</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{data.val}</Text>
                  </View>
                </View>
              )
            ))
          }
        </View>
      </Page>
    </Document>)
  );
  const handleSearch = async (e) => {
    e.preventDefault();
    const { user_id, status, country, start_date, end_date } = e.target;
    let rechargeData = {
      user_id: userId != false ? userId : "",
      start_date: start_date.value,
      end_date: end_date.value,
      status: status.value,
      country: country.value,
    };
    getData(rechargeData);
  };

  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
      user_id: pageData.user_id,
      start_date: pageData.start_date,
      end_date: pageData.end_date,
      status: pageData.status,
      country: pageData.country,
    };
    getData(rechargeData);
  };

  const getData = async (requestData) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/rechargeReport", requestData);
      const { status, data, records, body, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setRecordData(records);
        setPageData({ ...body, first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const showDetail = (e, rowIndex) => {
    e.preventDefault();
    handleShow();
    let rowData = data.data[rowIndex];
    setSingleTransectionRow([
      { key: "ID", val: rowData.transaction_id },
      { key: "Date", val: moment(rowData.created_at).format('MMM-DD-YYYY, hh:mm:ss A') },
      { key: "User(Mobile)", val: rowData?.user_id?.name + "(" + rowData?.user_id?.mobile + ")" },
      {
        key: "Service Provider",
        val: (
          <>
            {rowData?.provider?.provider_name}
            <img src={`${backendUrl}/${rowData?.provider?.image}`} alt={rowData?.provider?.provider_name} style={{ height: '45px', margin: '0px 0px 15px 10px' }} />
          </>
        )
      },
      { key: "Wallet Type", val: rowData.wallet_type },
      (rowData.wallet_type == "payu") ? ({ key: "Payu ID", val: rowData.payu_id }, { key: "UTR Number", val: rowData.utr_no }) : { key: "", val: "" },
      {
        key: "Provider",
        val: (
          <>
            <Image style={styles.provider} src={`${backendUrl}/${rowData?.provider?.image}`} alt={rowData?.provider?.provider_name} />
          </>
        )
      },
      { key: "Status", val: rowData?.state == "60" ? "Sucess" : rowData?.state == "40" ? "Pending" : "Failed" },
      { key: "NPR Amount", val: 'NPR ' + (rowData.amount - rowData.service_charge - rowData.gst_charge - rowData.addmoney_charge).toFixed(2) + '(' + ('INR ' + ((rowData.amount - rowData.service_charge - rowData.gst_charge - rowData.addmoney_charge) / 1.6).toFixed(2)) + ')' },
      { key: "Service Charge(8%)", val: 'NPR ' + (rowData.service_charge).toFixed(4) + '(' + ('INR ' + (rowData.service_charge / 1.6).toFixed(4)) + ')' },
      { key: "GST on processing fee(18%)", val: 'NPR ' + (rowData.gst_charge).toFixed(2) + '(' + ('INR ' + (rowData.gst_charge / 1.6).toFixed(2)) + ')' },
      { key: "Total Amount", val: 'NPR ' + (rowData.amount).toFixed(2) + '(' + ('INR ' + (rowData.amount / 1.6).toFixed(2)) + ')' },
      { key: "AddMoney Charges", val: 'NPR ' + (rowData.addmoney_charge).toFixed(2) + '(' + ('INR ' + (rowData.addmoney_charge / 1.6).toFixed(2)) + ')' },
      { key: "Message", val: rowData.message },
    ]);
  };
  const RefundMoney = async (id, user_id, amount) => {
    // try {
    //   const response = await axios.post("/refund/money", { id, status: 20, user_id, amount });
    //   const { status, message } = response.data;
    //   if (status) {
    //     document.querySelector(".search-btn").click();
    //     toast(message);
    //   }
    // }
    // catch (error) {
    //   if (error?.response?.data?.message) {
    //     toast(error.response.data.message);
    //   }
    // }
  };
  const ReloadTransaction = async (id) => {
    try {
      const response = await axios.post("/reports/recharge/details/check", { id });
      const { status, message } = response.data;
      if (status) {
        document.querySelector(".search-btn").click();
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  function addSpaceBetweenCases(str) {
    return capitalizeWords(str.replace(/([a-z])([A-Z])/g, '$1 $2')).replaceAll("_", " ");
  }
  function capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  const getData1 = async () => {
    try {
      const response = await axios.get("/get/all/users");
      const { status, users } = response.data;
      if (status) {
        setUsers(users);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    //getData1();
  }, []);

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setCurrentDate(today);
  }, []);

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions(false);
      setUserId("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query)}`).then((res) => {
      setSuggestions(res.data.users); // Adjust to your API response
      setLoading(false);
    }).catch(() => {
      setSuggestions(false);
      setLoading(false);
    });
  }, [query]);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Recharge Search</h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  {
                    currentUser && currentUser.user_type == "admin" && (
                      <div class="col-lg-3 col-md-3">
                        <label for="user_id">Users</label>
                        {/* <select class="form-control" name="user_id">
                          <option value="">--Select--</option>
                          {
                            users && users.map(user => (
                              <option value={user._id}>{user.name}</option>
                            ))
                          }
                        </select> */}
                        <input
                          type="text"
                          class="form-control"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          placeholder="Type to search..."
                        />

                        {suggestions && suggestions.length > 0 && (
                          <ul
                            style={{
                              border: "1px solid #ccc",
                              marginTop: 0,
                              paddingLeft: 0,
                              listStyleType: "none",
                              maxHeight: 150,
                              overflowY: "auto",
                              cursor: "pointer",
                            }}
                          >
                            {suggestions.map((item, idx) => (
                              <li
                                key={idx}
                                style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                                onClick={() => {
                                  setQuery(item.name + "(" + item.mobile + ")"); // Adjust as per your data structure
                                  setUserId(item._id);
                                  setSuggestions(false);
                                }}
                              >
                                {item.name + "(" + item.mobile + ")"}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )
                  }
                  <div class="col-lg-3 col-md-3">
                    <label>Status</label>
                    <select class="form-control" name="status">
                      <option value="">All</option>
                      <option value="60">Success</option>
                      <option value="40">Pending</option>
                      <option value="80">Failed</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>Country</label>
                    <select class="form-control" name="country">
                      <option value="">All</option>
                      <option value="india">India</option>
                      <option value="nepal">Nepal</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>From Date</label>
                    <input class="form-control" type="date" name="start_date" value={currentDate} max={today} onChange={(e) => setCurrentDate(e.target.value)} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>To Date</label>
                    <input class="form-control" type="date" name="end_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      Recharge Report
                    </h4>
                    <div className="row">
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Recharge</strong></label>
                        <div>NPR {(recordData?.totalRecharges).toFixed(2)}(₹ {(recordData?.totalRecharges / 1.6).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Service Charge</strong></label>
                        <div>NPR {(recordData?.totalServiceCharges).toFixed(2)}(₹ {(recordData?.totalServiceCharges / 1.6).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total GST Charge</strong></label>
                        <div>NPR {(recordData?.totalGstCharges).toFixed(2)}(₹ {(recordData?.totalGstCharges / 1.6).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Add Money Charge</strong></label>
                        <div>NPR {(recordData?.totalAddMoeyCharges).toFixed(2)}(₹ {(recordData?.totalAddMoeyCharges / 1.6).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>ClubApi Recharge(Commission)</strong></label>
                        <div>₹ {(recordData?.totalIndianCreditused).toFixed(2)}(₹ {(recordData?.totalIndianCommission).toFixed(2)})</div>
                      </div>
                    </div>
                    {/* <div className="row">
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Amount</strong></label>
                        <div>{data.total.amount}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Service Charge</strong></label>
                        <div>{data.total.service_charge}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>INR Amount</strong></label>
                        <div>{data.total.inr_total}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>GST Charge</strong></label>
                        <div>{data.total.gst_charge}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Add Money Charge</strong></label>
                        <div>{data.total.addmoney_charge}</div>
                      </div>
                    </div> */}
                    <DataTable
                      value={data.data}
                      size="small"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="transaction_id"
                        header="TxID"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="Date"><a href="javascript:void(0);" onClick={(e) => showDetail(e, rowIndex)}>{rowData.transaction_id}</a></span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="user_id"
                        header="User(mobile)"
                        sortable
                        body={(rowData) => <span data-label="Mobile">{rowData?.user_id?.name}<br />({rowData?.user_id?.mobile})</span>}
                      />
                      <Column
                        field="mobile"
                        header="Mobile/Subscriber"
                        sortable
                        body={(rowData) => <span data-label="Mobile/Subscriber">{rowData?.mobile}</span>}
                      />
                      <Column
                        field="payu_id"
                        header="PayuId"
                        sortable
                        body={(rowData) => <span data-label="PayuId">{rowData.utr_no}</span>}
                      />
                      <Column
                        field="wallet_type"
                        header="WalletType"
                        sortable
                        body={(rowData) => <span data-label="wallet_type">{rowData.wallet_type}<br />({rowData.type})</span>}
                      />
                      <Column
                        field="provider"
                        header="Provider"
                        sortable
                        body={(rowData) => <span data-label="Mobile">{rowData?.provider?.provider_name}</span>}
                      />
                      {/* <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => <span data-label="Mobile">{rowData?.state == "60" ? "Sucess" : rowData?.state == "40" ? "Pending" : "Failed"}</span>}
                      /> */}
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => (
                          <span data-label="Mobile">
                            {rowData?.state === "60" ? (
                              <span className="success">Success</span>
                            ) : rowData?.state === "40" ? (
                              <span className="pending">Pending</span>
                            ) : (
                              <span className="failed">Failed</span>
                            )}
                          </span>
                        )}
                      />
                      <Column
                        field="amount"
                        header="NPRAmount"
                        sortable
                        body={(rowData) => <span data-label="Mobile">NPR {(rowData.recharge_amount).toFixed(3)}<br />(INR {((rowData.recharge_amount) / 1.6).toFixed(3)})</span>}
                      />
                      <Column
                        field="service_charge"
                        header="ServiceCharge"
                        sortable
                        body={(rowData) => <span data-label="Mobile">NPR {(rowData.service_charge).toFixed(4)}<br />(INR {(rowData.service_charge / 1.6).toFixed(4)})</span>}
                      />
                      <Column
                        field="gst_charge"
                        header="GST"
                        sortable
                        body={(rowData) => <span data-label="Mobile">NPR {(rowData.gst_charge).toFixed(3)}<br />(INR {(rowData.gst_charge / 1.6).toFixed(3)})</span>}
                      />
                      <Column
                        field="amount"
                        header="Total"
                        sortable
                        body={(rowData) => <span data-label="Mobile">NPR {(rowData.amount).toFixed(3)}<br />(INR {(rowData.amount / 1.6).toFixed(3)})</span>}
                      />
                      <Column
                        field="addmoney_charge"
                        header="AddMoney Charges"
                        sortable
                        body={(rowData) => <span data-label="Mobile">NPR {(rowData.addmoney_charge).toFixed(3)}<br />(INR {(rowData.addmoney_charge / 1.6).toFixed(3)})</span>}
                      />
                      <Column
                        field="message"
                        header="Message"
                        sortable
                        body={(rowData) => <span data-label="Mobile">{rowData.message}</span>}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData) => (
                            <span data-label="Action">
                              {rowData?.state == "40" ? (<button className="btn btn-primary" onClick={(e) => ReloadTransaction(rowData?._id)}>Reload</button>) : ""}
                            </span>
                          )
                        }
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={showModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Transection Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {
              data && singleTransectionRow && (
                <ul className="showData">
                  {
                    singleTransectionRow.map(data => (
                      data.key != "Provider" && data.key != "" && (
                        <li>
                          <strong>{data.key}:</strong>
                          <div>{data.val}</div>
                        </li>
                      )
                    ))
                  }
                </ul>
              )
            }
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {typeof window !== 'undefined' && showModal && (
            <PDFDownloadLink className="btn btn-primary" document={<PrintPDF />} fileName="mypdf.pdf">
              {({ blob, url, loading, error }) =>
                loading ? 'Loading document...' : 'Print'
              }
            </PDFDownloadLink>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default RechargeReport;
